const ARS = new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', minimumFractionDigits: 2 });

export const fmtMoney = (n) => (n == null || Number.isNaN(n) ? '—' : ARS.format(n));

export const fmtFechaHora = (iso) => {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleString('es-AR', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' });
  } catch { return iso; }
};

// Acepta "15.000", "15000,50", "$ 1.234,56" o "15000.5".
export const parseMontoAR = (txt) => {
  let s = String(txt || '').replace(/[$\s]/g, '').replace(/^-/, '');
  if (!s) return null;
  if (s.includes(',')) s = s.replace(/\./g, '').replace(',', '.');
  else if (/^\d{1,3}(\.\d{3})+$/.test(s)) s = s.replace(/\./g, '');
  const n = parseFloat(s);
  return Number.isFinite(n) && n > 0 ? n : null;
};

export const ESTADOS = {
  PENDIENTE: { label: 'Preparando', cls: 'bg-slate-100 text-slate-700' },
  EN_PROGRESO: { label: 'Buscando', cls: 'bg-amber-100 text-amber-800' },
  COMPLETADA: { label: 'Terminada', cls: 'bg-green-100 text-green-800' },
  CANCELADA: { label: 'Cancelada', cls: 'bg-slate-200 text-slate-700' },
  INTERRUMPIDA: { label: 'Interrumpida', cls: 'bg-orange-100 text-orange-800' },
  ERROR: { label: 'Error', cls: 'bg-red-100 text-red-700' },
};

export const esActiva = (estado) => estado === 'PENDIENTE' || estado === 'EN_PROGRESO';
